<template>
  <div class="dashboard">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex md12 lg8>
          <calendar />
        </v-flex>

        <v-flex md12 lg4>
          <crew-list />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Calendar from '../components/Calendar.vue';
import CrewList from '../components/CrewList.vue';

export default {
  components: {
    CrewList,
    Calendar
  }
};
</script>
